module.exports = __webpack_public_path__ + "static/img/14000102.fcea43d2.png";